import React, { useState } from "react";
import "./Input.scss";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
import { FaFile } from "react-icons/fa";

type InputProps = {
    name?: string;
    type?: string;
    label?: string;
    labelVisible?: boolean;
    placeholder?: string;
    multipleFiles?: boolean;
    value?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export default function Input({
    name,
    type = "text",
    label,
    labelVisible = true,
    placeholder,
    multipleFiles = false,
    value,
    onChange,
    ...props
}: InputProps) {
    const [inputValue, setInputValue] = useState(value || "");
    const [showPassword, setShowPassword] = useState(false);

    const inputType = type === "password" && showPassword ? "text" : type;

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(event.target.value);
        if (onChange) {
            onChange(event);
        }
    };

    return (
        <div className={`input input--${type}`}>
            {labelVisible && label && (
                <label className="input__label">{label}</label>
            )}

            <div className="input__wrapper">
                <div className="input__text">
                    {type === "file" && (
                        <>
                            {(FaFile as any)({})}
                            <span className="input__text__placeholder">
                                {placeholder}
                            </span>
                        </>
                    )}
                </div>
                <input
                    name={name}
                    className={`input__element input__element--${type}`}
                    type={inputType}
                    autoComplete="nope"
                    placeholder={placeholder}
                    value={inputValue}
                    onChange={handleChange}
                    multiple={type === "file" && multipleFiles}
                    {...props}
                />
                {type === "password" && (
                    <span
                        className="input__icon"
                        onClick={() => setShowPassword(!showPassword)}
                    >
                        {showPassword
                            ? (IoEyeOffOutline as any)({ size: 20 })
                            : (IoEyeOutline as any)({ size: 20 })}
                    </span>
                )}
            </div>
        </div>
    );
}
